/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

export function createImportMap( { hasPremiumPlugins }: { hasPremiumPlugins: boolean } ): string {
	const importMap = {
		imports: {
			'ckeditor5': './ckeditor5/ckeditor5.js',
			'ckeditor5/': './ckeditor5/',
			...hasPremiumPlugins ? {
				'ckeditor5-premium-features': './ckeditor5-premium-features/ckeditor5-premium-features.js',
				'ckeditor5-premium-features/': './ckeditor5-premium-features/'
			} : {}
		}
	};

	return JSON.stringify( importMap, null, '\t' );
}
